import ModalBookbinding from './ModalBookbinding.vue'

export { ModalBookbinding }
